module.exports = __webpack_public_path__ + "img/logo.6cd589b7.png";